
import axios from 'axios';

export const getGoogleTextToSpeechService = async (text, languageCode = 'en-US') => {

  const requestData = {
    input: { text: text },
    voice: { languageCode: languageCode, ssmlGender: 'FEMALE' }, // You can set different voices here
    audioConfig: { audioEncoding: 'MP3' },
  };

  const YOUR_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

  const apiKey = YOUR_GOOGLE_API_KEY; // Replace with your API key

  try {
    const response = await axios.post(
      `https://texttospeech.googleapis.com/v1/text:synthesize?key=${apiKey}`,
      requestData,
      { headers: { 'Content-Type': 'application/json' } }
    );
    const audioContent = response.data.audioContent;
    const audioUrl = `data:audio/mp3;base64,${audioContent}`;
    console.log('audioUrl Service', audioUrl);
    return audioUrl;
  } catch (error) {
    console.error('Error generating speech:', error);
  }
};
